export enum QuoteTvOptimisation {
  Control = 'control',
  Variant = 'variant',
}
